<section class="schedules-view">
  @if (schedules().collectiveSchedules) {
    <div class="collective-schedules">Horaires collectifs</div>
  }
  <div class="schedules">
    @for (daySchedule of schedules().schedules; track $index) {
      @let dayChanged = dayChange(daySchedule.day);
      <app-label-value
        [class.changed]="!!dayChanged"
        [matTooltip]="dayChanged"
        [label]="daySchedule.day | dayOfWeekLabel"
        [value]="daySchedule.slots | slotsDuration | colonToH"
      ></app-label-value>
    }
  </div>
  @let weeklyChanged = weeklyChange();
  <table class="overview">
    <tr>
      <td [class.changed]="!!weeklyChanged" [matTooltip]="weeklyChanged">
        <app-label-value
          label="h/sem"
          [value]="schedules().schedules | scheduleWeeklyDuration | hoursToDecimal"
          [reverse]="true"
        ></app-label-value>
      </td>
      <td [class.changed]="!!weeklyChanged" [matTooltip]="weeklyChanged">
        <app-label-value
          label="h/mois"
          [value]="schedules().schedules | scheduleMonthlyDuration | hoursToDecimal"
          [reverse]="true"
        ></app-label-value>
      </td>
    </tr>
    <tr>
      <td>
        <app-label-value
          label="/sem"
          [value]="
            contract().grossHourlySalary
              | periodSalary: (schedules().schedules | scheduleWeeklyDuration)
              | currency: 'EUR' : 'symbol' : '1.2-2'
          "
          [reverse]="true"
        ></app-label-value>
      </td>
      <td>
        <app-label-value
          label="/mois"
          [value]="
            contract().grossHourlySalary
              | periodSalary: (schedules().schedules | scheduleMonthlyDuration)
              | currency: 'EUR' : 'symbol' : '1.2-2'
          "
          [reverse]="true"
        ></app-label-value>
      </td>
    </tr>
  </table>
</section>
